var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 4.082H17.5V1.385c0-.192-.188-.385-.375-.385h-.75c-.234 0-.375.193-.375.385v2.697H7V1.385C7 1.193 6.812 1 6.625 1h-.75c-.234 0-.375.193-.375.385v2.697H3.25C1.984 4.082 1 5.14 1 6.392v16.949c0 1.3.984 2.311 2.25 2.311h16.5c1.219 0 2.25-1.01 2.25-2.311V6.393c0-1.252-1.031-2.311-2.25-2.311zm.75 19.259c0 .433-.375.77-.75.77H3.25a.75.75 0 01-.75-.77V10.245h18V23.34zm0-14.637h-18V6.393c0-.386.328-.77.75-.77h16.5c.375 0 .75.384.75.77v2.31zM6.25 19.489h4.5c.375 0 .75-.337.75-.77v-4.623c0-.385-.375-.77-.75-.77h-4.5c-.422 0-.75.385-.75.77v4.623c0 .433.328.77.75.77zM7 14.867h3v3.081H7v-3.081z",
    fill: "#02555B",
    stroke: "#02555B",
    strokeWidth: 0.2
  })));
}
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL2Nzcy9jMzlhMzA5NmUzZWI0NDliODlkYWVjZWFlNWY4ZWI2MC5zdmciOw==";
export { SvgCalendar1 as ReactComponent };